export class ImageCaptureState {
  public imageData: string;
  public fileName: string;
  public latitude: number;
  public longitude: number;
  public createdOn: Date;
  public readyForReview = false;
  public readyForUpload = false;
  public readyForDelete = false;

  constructor(
    imageData: string,
    fileName: string,
    readyForReview: boolean,
    latitude: number,
    longitude: number,
    createdOn: Date,
  ) {
    this.imageData = imageData;
    this.fileName = fileName;
    this.readyForReview = readyForReview;
    this.latitude = latitude;
    this.longitude = longitude;
    this.createdOn = createdOn;
  }

  public markAsAccepted(): void {
    this.readyForUpload = true;
    this.readyForReview = false;
  }

  public markAsDeleted(): void {
    this.readyForDelete = true;
  }

  public markAsUploaded(): void {
    this.readyForUpload = false;
  }
}
